import { reads } from '@ember/object/computed';
import classic from 'ember-classic-decorator';
import BaseValidator from 'ember-cp-validations/validators/base';

@classic
export default class WebpFormat extends BaseValidator {
  @reads('model.mediaItem.processingKey') processingKey;
  @reads('model.mediaItem.originalFilename') originalFilename;

  get isWebp() {
    const key = this.processingKey || this.originalFilename || '';
    return key.split('?')[0].trim().toLowerCase().endsWith('.webp');
  }

  validate() {
    if (!this.model?.get('mediaItem') || !this.model?.get('gram')) {
      return true;
    }
    if (this.isWebp && !this.model.get('isTiktok')) {
      return this.createErrorMessage('webpNotSupported');
    }
    return true;
  }
}
